// extracted by mini-css-extract-plugin
export default {"SanitizedHtml":"text-cell-module__SanitizedHtml--t3zAN"};